<template>
  <div class="px-5 pb-5" style="height: calc(100% - 64px)">
    <div>
      <div class="d-flex align-center px-0 py-2">
        <span class="pa-3 grey lighten-3 rounded">
          <v-icon>mdi-account</v-icon>
        </span>
        <div class="ml-2">Get Employee Info</div>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="
            command.status === 'send_command' ||
            command.status === 'connect' ||
            command.status === 'process' ||
            !selectedEmployee
          "
          color="primary"
          outlined
          @click="handleSendCommand"
        >
          {{ command.status === null ? 'ส่งคำสั่ง' : 'ส่งคำสั่งอีกครั้ง' }}
        </v-btn>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="mt-2" style="height: 100%" v-if="command.status === null">
      <CardHardwareCommandEmployees
        @onCheckEmployee="(value) => (selectedEmployee = value)"
        @onClearEmployee="selectedEmployee = null"
      />
    </div>
    <div
      class="mt-2"
      v-else
      style="height: calc(100% - 55px); overflow-y: auto"
    >
      <v-alert
        v-if="command.status === 'connect'"
        outlined
        type="info"
        icon="mdi-swap-horizontal"
        text
        dense
      >
        <div>กำลังติดต่อ Device</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'process'"
        outlined
        type="info"
        icon="mdi-autorenew"
        text
        dense
      >
        <div>รอ Device ดำเนินการ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'success'"
        outlined
        type="success"
        icon="mdi-check-circle-outline"
        text
        dense
      >
        <div>สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'fail'"
        outlined
        type="error"
        icon="mdi-close-circle-outline"
        text
        dense
      >
        <div>ไม่สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <div v-if="command.status === 'success'">
        <div
          v-if="
            ['acu01r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div
            v-for="group in command.responseData"
            :key="group.group_key"
            class="mb-6"
          >
            <div>
              <p
                class="mb-2"
                style="font-weight: 600; font-size: 16px; color: #212121"
              >
                {{ group.group_name }}
              </p>
              <v-divider></v-divider>
              <v-list-item
                class="pl-0"
                two-line
                v-for="item in group.items"
                :key="group.group_key + '_' + item.key"
              >
                <v-list-item-content
                  v-if="
                    (item.key === 'photo_identifier' ||
                      item.key === 'face_data') &&
                    item.value
                  "
                >
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    <v-img
                      style="width: 64px"
                      :src="'data:image/jpeg;base64,' + item.value"
                      aspect-ratio="1"
                    ></v-img>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.value || '-' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div v-else>
          <v-list-item
            two-line
            v-for="(value, key) in command.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
      <div v-if="command.status === 'fail'">
        <div
          v-if="
            ['acu01r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div
            v-for="group in command.responseData"
            :key="group.group_key"
            class="mb-6"
          >
            <div>
              <p
                class="mb-2"
                style="font-weight: 600; font-size: 16px; color: #212121"
              >
                {{ group.group_name }}
              </p>
              <v-divider></v-divider>
              <v-list-item
                class="pl-0"
                two-line
                v-for="item in group.items"
                :key="group.group_key + '_' + item.key"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.value || '-' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div v-else>
          <v-list-item
            two-line
            v-for="(value, key) in command.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

import CardHardwareCommandEmployees from '@/components/CardHardwareCommandEmployees.vue'

export default {
  components: {
    CardHardwareCommandEmployees,
  },

  props: {
    hardware: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedEmployee: null,
      command: {
        status: null,
        date: null,
        responseData: null,
      },
      syncJobId: null,
    }
  },

  computed: {
    employeeInfoTranslate() {
      return this.$store.state.hardware.employeeInfoTranslate
    },
  },

  async created() {
    try {
      await this.fetchEmployeeInfoTranslate()
    } catch (error) {
      if (error.response && error.response.data) {
        this.command = {
          status: 'fail',
          date: new Date(),
          responseData: {
            Type: 'Get Employee Info Fail',
            Message: error.response.data.message || 'Error',
          },
        }
      }
    }
  },

  methods: {
    ...mapActions({
      getEmployee: 'hardware/getEmployee',
      fetchJob: 'hardware/fetchJob',
      userAcknowledge: 'hardware/userAcknowledge',
      fetchEmployeeInfoTranslate: 'hardware/fetchEmployeeInfoTranslate',
    }),

    async handleSendCommand() {
      if (this.command.status === null) {
        try {
          this.command = { status: 'send_command' }

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            hardware_model: this.hardware.hardware_model.hardware_model_code,
            body: {
              hardware_uuid: this.hardware.hardware_uuid,
              data: {
                employee_uuid: this.selectedEmployee,
              },
            },
          }

          const response = await this.getEmployee(payload)

          this.command = {
            status: 'connect',
            date: response.create_datetime,
          }
          this.syncJob(response.sync_job_uuid)
        } catch (error) {
          if (error.response && error.response.data) {
            this.command = {
              status: 'fail',
              date: new Date(),
              responseData: {
                Type: 'Get Employee Info Fail',
                Message: error.response.data.message || 'Error',
              },
            }
          }

          this.command = {
            status: null,
            date: null,
            responseData: null,
          }
        }
      } else {
        this.selectedEmployee = null

        this.command = {
          status: null,
          date: null,
          responseData: null,
        }
      }
    },

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        if (
          res.command === 'get_employee' &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeInfoTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) => {
                return {
                  key: subItem.key,
                  key_name:
                    this.employeeInfoTranslate?.keys[subItem.key]?.th ||
                    subItem.key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: subItem.value,
                  type: subItem.type,
                }
              }),
            }
          })

          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        } else {
          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: res.response_json,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        }
      } else if (res.done_datetime && !res.is_response_success) {
        if (
          ['get_employee'].includes(res.command) &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeInfoTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) => {
                return {
                  key: subItem.key,
                  key_name:
                    this.employeeInfoTranslate?.keys[subItem.key]?.th ||
                    subItem.key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: subItem.value.toString().trim(), // fix int and space
                  type: subItem.type,
                }
              }),
            }
          })

          this.command = {
            status: 'fail',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
          return
        }

        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            Type: res.response_json?.error_type || 'Error Type',
            Message: res.response_json?.error_message || 'Error Message',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
